enum FlowItemTypes {
	FlowStart = 'FlowStart',
	FlowEnd = 'FlowEnd',
	FlowAssign = 'FlowAssign',
	FlowCompare = 'FlowCompare',
	FlowProfession = 'FlowProfession',
	FlowDepartment = 'FlowDepartment',
	Variable = 'Variable',
	FlowState = 'FlowState',
	FlowParallel = 'FlowParallel',
	FlowAnd = 'FlowAnd',
	FlowOr = 'FlowOr',
	FlowNode = 'FlowNode',
	FlowStarterPosition = 'FlowStarterPosition',
	FlowPosition = 'FlowPosition',
	FlowGroup = 'FlowGroup',
	FlowMail = 'FlowMail',
	FlowApprovalCancellar = 'FlowApprovalCancellar',
	FlowScript = 'FlowScript',
	FlowPDFExport = 'FlowPDFExport',
	FlowUniqueIdCreator = 'FlowUniqueIdCreator',
	FlowMailSender = 'FlowMailSender',
	FlowDocument = 'FlowDocument',
	FlowDocumentState = 'FlowDocumentState',
	FlowDocumentSynchronizer = 'FlowDocumentSynchronizer',
	SubFlowCall = 'SubFlowCall',
	SubFlowBegin = 'SubFlowBegin',
	SubFlowEnd = 'SubFlowEnd',
	FlowPushNotification = 'FlowPushNotification',
	FlowTimer = 'FlowTimer',
	FlowTimerStarter = 'FlowTimerStarter',
	FlowTimerStopper = 'FlowTimerStopper',
	FlowCreateDocument = 'FlowCreateDocument',
	FlowSetDocumentId = 'FlowSetDocumentId',
	FlowDeleteDocument = 'FlowDeleteDocument',
	Pauser = 'Pauser',
	Continue = 'Continue',
	FlowTrigger = 'FlowTrigger',
	FlowActionCreator = 'FlowActionCreator',
	FlowGptPrompt = 'FlowGptPrompt'
}

export { FlowItemTypes };
